export default {
  on: {
    pageInit() {
      // 결제내역조회
      var search_date = this.getToday();
      this.$$('#search_date').val(search_date);

      this.getTouristUsedList();
    }
  },
  data() {
    var search_date = this.getToday();
    var list_item_height = (this.$f7.theme == 'ios') ? 112 : 121;

    return {
      search_date: search_date,
      search_text: '',
      list_payment: [],
      list_item_height: list_item_height,
      vlData: {},

      daily_payment_amount: 0,
      cnt_adult_postpay: 0,
      cnt_youth_postpay: 0,
      cnt_child_postpay: 0,
      cnt_adult_package: 0,
      cnt_youth_package: 0,
      cnt_child_package: 0,
      cnt_adult_single: 0,
      cnt_youth_single: 0,
      cnt_child_single: 0,
      sum_adult: 0,
      sum_youth: 0,
      sum_child: 0,

      cnt_success: 0,
      cnt_fail: 0,
      cnt_cancel: 0,
    }
  },
  methods: {
    getToday() {
      var today = new Date();
      var year  = today.getFullYear();
      var month = today.getMonth()+1;
      var day   = today.getDate();
      return year.toString() + '-' + (month < 10 ? '0'+month : month) + '-' + (day < 10 ? '0'+day : day);
    },
    formatNumber(value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    /**
     * 결제내역 조회
     */
    getTouristUsedList() {
      var _this = this;
      _this.$f7.dialog.preloader('결제내역 조회 중');

      var formdata = new FormData();
      formdata.set('tourist_id', localStorage.tourist_id);
      formdata.set('date', _this.search_date);
      formdata.set('search_text', _this.search_text);

      this.$http.post(_this.$api_base_uri + '/get_tourist_used_list', formdata, {
        timeout: 30000,
      })
      .then(function(response) {
        _this.$f7.dialog.close();

        // 목록 저장용 배열 초기화
        if (_this.list_payment.length > 0) {
          _this.list_payment.splice(0, _this.list_payment.length);
        }

        // 결제내역 처리
        var cnt_list = response.data.list_used.length;
        for (var i = 0; i < cnt_list; i++) {
          // 상품명
          var goods_name = (response.data.list_used[i].goods_nickname != '') ? response.data.list_used[i].goods_nickname : response.data.list_used[i].goods_name;

          // 승인금액
          var payment_amount = '';
          if (response.data.list_used[i].prepost_type == 'PO') {
            payment_amount = _this.formatNumber(response.data.list_used[i].auth_amount) + '원';    // 후불
          } else {
            payment_amount = (response.data.list_used[i].seller_price_type == 'S') ? '단품' : '패키지';    // 선불
          }

          // 결제정보
          var info_user = response.data.list_used[i].user_name + ' ' + response.data.list_used[i].user_mobile;
          var info_people = '성인: ' + response.data.list_used[i].cnt_adult + '명, 청소년: ' + response.data.list_used[i].cnt_youth + '명, 소인: ' + response.data.list_used[i].cnt_child + '명';
          var info_payment = goods_name + ', 승인금액: ' + payment_amount;

          _this.list_payment.push({
            used_id: response.data.list_used[i].used_id,
            info_user: info_user,
            info_people: info_people,
            info_payment: info_payment,
            used_date: response.data.list_used[i].format_used_date,
            barcode: response.data.list_used[i].barcode,
            cancel_yn: response.data.list_used[i].cancel_yn,
            payment_state: response.data.list_used[i].payment_state,
            cancel_avail_yn: 'Y'  // response.data.list_used[i].cancel_avail_yn
          });
        } // end of for

        // 목록 업데이트
        _this.$f7.virtualList.get('#list_payment').update();

        // 일일결제정보
        _this.daily_payment_amount = _this.formatNumber(response.data.total_payment_amount);   // 결제금액
        _this.cnt_success = _this.formatNumber(response.data.cnt_success);   // 승인 건 수
        _this.cnt_fail    = _this.formatNumber(response.data.cnt_fail);      // 실패 건 수
        _this.cnt_cancel  = _this.formatNumber(response.data.cnt_cancel);    // 취소 건 수

        // 후불 인원수
        _this.cnt_adult_postpay = _this.formatNumber(response.data.cnt_adult_postpay);
        _this.cnt_youth_postpay = _this.formatNumber(response.data.cnt_youth_postpay);
        _this.cnt_child_postpay = _this.formatNumber(response.data.cnt_child_postpay);
        // 선불 인원수
        _this.cnt_adult_package = _this.formatNumber(response.data.cnt_adult_package);
        _this.cnt_youth_package = _this.formatNumber(response.data.cnt_youth_package);
        _this.cnt_child_package = _this.formatNumber(response.data.cnt_child_package);
        // 단품 인원수
        _this.cnt_adult_single = _this.formatNumber(response.data.cnt_adult_single);
        _this.cnt_youth_single = _this.formatNumber(response.data.cnt_youth_single);
        _this.cnt_child_single = _this.formatNumber(response.data.cnt_child_single);
        // 합계
        _this.sum_adult = _this.formatNumber(response.data.sum_adult);
        _this.sum_youth = _this.formatNumber(response.data.sum_youth);
        _this.sum_child = _this.formatNumber(response.data.sum_child);
      })
      .catch(function(error) {
        console.log(error);
        _this.$f7.dialog.close();
        _this.$f7.dialog.alert('결제내역 조회 중 오류가 발생했습니다.<br/>' + error, '결제내역조회');
      });
    },

    /**
     * 조회일자 변경
     */
    onChangePaymentDate(event) {
      // 관광지아이디 체크
      var tourist_id = localStorage.tourist_id;
      if (tourist_id == undefined  ||  tourist_id == null  ||  tourist_id == '') {
        var msg = (this.$root.$data.group_code == 'A')  ?  '환경설정에서 관광지를 설정해 주세요.'  :  '로그인 후 시도해 주세요.';
        this.$f7.dialog.alert(msg, '결제내역조회');
        return;
      }

      // 결제내역 조회
      this.$f7.input.blur(event.target);
      this.getTouristUsedList();
    },

    /**
     * 승인취소
     */
    cancelTicket(index, used_id) {
      var _this = this;
      this.$f7.dialog.confirm('정말 승인취소 하시겠습니까?', '승인취소', function() {
        _this.$f7.dialog.preloader('잠시만 기다려주세요.');

        var formdata = new FormData();
        formdata.set('tourist_id', localStorage.tourist_id);
        formdata.set('used_id', used_id);
  
        _this.$http.post(_this.$api_base_uri + '/ticket_cancel', formdata, {
          timeout: 30000
        })
        .then(function(response) {
          console.log(response);

          _this.$f7.dialog.close();
          _this.$f7.dialog.alert(response.data.msg, '승인취소', function() {
            if (response.data.result) {
              setTimeout(function () {
                _this.$f7.swipeout.close( _this.$$('li.swipeout').eq(index) );
                _this.getTouristUsedList();
              }, 500);
            }
          });
        })
        .catch(function(error) {
          console.log(error);
          _this.$f7.dialog.close();
          _this.$f7.dialog.alert('승인취소 처리 중 오류가 발생했습니다.<br>' + error, '승인취소');
        });
      });
    },

    /**
     * 검색
     */
    searchAll: function(query, items) {
      var found = [];
      for (var i = 0; i < items.length; i += 1) {
        if (items[i].info_user.toLowerCase().indexOf(query) >= 0 || query.trim() === '') {
          found.push(i);
        }
      }
      return found;
    },
    renderExternal(vl, vlData) {
      this.vlData = vlData;
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/payment-list.js